import * as runtime from '@/api/runtime'
import {
  BatchStatisticsPageLoadRequest,
  BatchStatisticsPageLoadRequestToJSON
} from '@/api'
import {
  BatchCollectionMgmtCollectionBulkRemovalRequest,
  BatchCollectionMgmtCollectionBulkRemovalRequestToJSON
} from '@/api/models/batch/BatchCollectionMgmtCollectionBulkRemovalRequest'
import {
  BatchCollectionMgmtCollectionBulkRemovalPageLoadResult,
  BatchCollectionMgmtCollectionBulkRemovalPageLoadResultFromJSON
} from '@/api/models/batch/BatchCollectionMgmtCollectionBulkRemovalPageLoadResult'

export class BatchCollectionMgmtCollectionBulkRemovalApi extends runtime.BaseAPI {
  /**
   * 画面初期表示時の検索状態取得
   * @param request
   */
  async readInitialPattern(
    request: BatchStatisticsPageLoadRequest
  ): Promise<BatchCollectionMgmtCollectionBulkRemovalPageLoadResult> {
    const response = await this.requestGet(
      `/batch/statistics/search_initial_condition`,
      BatchStatisticsPageLoadRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      BatchCollectionMgmtCollectionBulkRemovalPageLoadResultFromJSON(jsonValue)
    ).value()
  }

  async createCollectionMgmtCollectionBulkRemoval(
    request: BatchCollectionMgmtCollectionBulkRemovalRequest
  ): Promise<number> {
    const response = await this.requestPost(
      `/batch/collection-management/collection-bulk-removal`,
      BatchCollectionMgmtCollectionBulkRemovalRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      Number(jsonValue.request_id)
    ).value()
  }
}
